<label><slot></slot></label>